@import "../../../node_modules/@genexus/mercury/dist/assets/scss/helpers.scss"; // for the tabular-grid-cell-layout mixin
@import "../../global/temporary-mercury-overrides/_button.scss";

:host {
  block-size: 100%;
  display: grid;
  grid-template-rows: auto 1fr auto;
  overflow: auto;
}

.section {
  display: contents;
}

/* Filters */
.filter-layout {
  grid-template:
    "pattern type"
    "category module"
    "modified modified";
  grid-template-columns: 1fr 1fr;
}
.pattern {
  grid-area: pattern;
}
.type {
  grid-area: type;
}
.category {
  grid-area: category;
}
.module {
  grid-area: module;
}
.modified-accordion {
  grid-area: modified;
  display: flex;
  flex-direction: column;
}
.field-group-modified {
  grid-template-columns: 1fr 1fr 1fr;
}

gx-ide-container::part(content) {
  // only apply display grid when the loader is being displayed, to stretch the container.
  display: grid;
}

/*tabular grid*/
ch-tabular-grid {
  overflow: auto;
}
@include tabular-grid-cell-layout(
  $tabular-grid-selector: ".tabular-grid-object-selector",
  $tabular-grid-cell-node-type: "text",
  $tabular-grid-cell-apply-ellipsis: true,
  $tabular-grid-affected-columns-nth-list: (
    5
  )
);

// Objects Table
.objects-count {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-block-start: 1px solid
    var(--color-border-surface-on-elevation-3);
}
.objects-selected,
.objects-matching {
  padding-block-end: 8px;
}

ch-tabular-grid-rowset-empty {
  position: relative; // makes this the bounder element for the loader
}

ch-tabular-grid.empty-result::part(main) {
  // WA to avoid scrollbar flickering when displaying the empty-state message
  overflow: hidden;
}

input::-webkit-datetime-edit-fields-wrapper {
  // WA remove padding to force this input block-size to be the same as other
  // mercury controls block size.
  padding: none;
}
